import b from 'b_';
import { observer } from 'mobx-react';
import PropTypes from 'prop-types';
import React, { Component, Fragment } from 'react';
import FuseSearchTextStore from '../../stores/FuseSearchTextStore';
import InputStore from '../../stores/InputStore';
import FuseTextfield from '../FuseControls/FuseTextfield';
import Icon from '../Icon/Icon';
import './FuseSearchText.css';

const block = b.lock('FuseSearchText');
const KEYBOARD_SPACE = 32;
const KEYBOARD_ENTER = 13;
const KEYBOARD_ARROW_DOWN = 40;
const KEYBOARD_ARROW_UP = 38;

export default class FuseSearchText extends Component {
    static propTypes = {
        inputStore: InputStore.PropType.isRequired,
        searchCount: PropTypes.number,
        searchIndex: PropTypes.number,
        searchForward: PropTypes.func,
        searchBack: PropTypes.func,
        setSearchValue: PropTypes.func,
        placeholder: PropTypes.node,
        reset: PropTypes.func,
    };

    componentWillUnmount() {
        this.props.inputStore.reset();
    }

    constructor(props) {
        super(props);
        this.inputStore = new InputStore({ onChangeHandler: this.onSearchValueChangeHandler });
    }

    renderSearchData() {
        return (<Fragment>
            <span onKeyDown={this.onKeyDownCancelSearch} className={block('IconWrapper')} tabIndex={0}>
                <Icon onMouseDown={this.cancelSearch} className={block('Button', { cancel: true })} type={'cancel'} />
            </span>
            <div className={block('SearchData')}>
                {`${this.props.searchIndex.toLocaleString()}/${this.props.searchCount.toLocaleString()}`}</div>
        </Fragment>);
    }

    renderSearchControl() {
        return <Fragment>{(!this.isEmpty()) ?
            this.renderSearchData() : null}<div className={block('Divider')}>|</div>
        <span onKeyDown={this.handleKeyDownTriggerSearchBack} className={block('IconWrapper')} tabIndex={0}>
            <Icon onMouseDown={this.searchBack} className={block('Button')} type={'keyboard_arrow_up'} /></span>
        <span onKeyDown={this.handleKeyDownTriggerSearchForward} className={block('IconWrapper')} tabIndex={0}>
            <Icon onMouseDown={this.searchForward} className={block('Button')} type={'keyboard_arrow_down'} /></span>
        </Fragment>;
    }

    render() {
        const {
            inputStore, placeholder,
        } = this.props;
        return (<FuseTextfield
            className={block('SearchTextField')}
            store={inputStore}
            onKeyDown={this.handleOnKeyDown}
            placeholder={<span><Icon className={block('SearchIcon')} type={'search'} />
                <div className={block('PlaceHolderText')}>{placeholder}</div></span>}
            rightChild={this.renderSearchControl()}
        />);
    }

    isEmpty = () => {
        return !(this.props.inputStore.value && this.props.inputStore.value !== '');
    }

    searchBack = (e) => {
        e.preventDefault();
        this.props.searchBack();
    }

    searchForward = (e) => {
        e.preventDefault();
        this.props.searchForward();
    }


    onSearchValueChangeHandler = ({ target }) => {
        this.props.setSearchValue(target.value);
    };

    cancelSearch = (e) => {
        e.preventDefault();
        this.props.setSearchValue('');
    }

    handleOnKeyDown = (e) => {
        const pressEvent = e || window.event;
        const key = pressEvent.which || pressEvent.keyCode;
        if (key === KEYBOARD_ENTER || key === KEYBOARD_ARROW_DOWN) {
            this.props.searchForward();
        }
        if (key === KEYBOARD_ARROW_UP) {
            this.props.searchBack();
        }
    }

    handleKeyDownTriggerSearchBack = (e) => {
        this.handleKeyPressWhenSearchButtonInFocus(e, false);
    }

    handleKeyDownTriggerSearchForward = (e) => {
        this.handleKeyPressWhenSearchButtonInFocus(e, true);
    }

    onKeyDownCancelSearch = (e) => {
        const pressEvent = e || window.event;
        const key = pressEvent.which || pressEvent.keyCode;
        if (key === KEYBOARD_ENTER || key === KEYBOARD_SPACE) {
            this.cancelSearch(e);
        }
    }

    handleKeyPressWhenSearchButtonInFocus = (e, forward) => {
        const pressEvent = e || window.event;
        const key = pressEvent.which || pressEvent.keyCode;
        if (key === KEYBOARD_ENTER || key === KEYBOARD_SPACE) {
            if (forward) {
                this.props.searchForward();
            } else {
                this.props.searchBack();
            }
        }
    }
}

export const ObservableFuseSearchText =
    observer(({ store, ...props }) => <FuseSearchText
        searchCount={store.searchCount}
        searchIndex={store.searchIndex}
        searchForward={store.searchForward}
        searchBack={store.searchBack}
        inputStore={store.inputStore}
        setSearchValue={store.setSearchValue}
        placeholder={store.placeholder}
        reset={store.reset}
        {...props}
    />);

ObservableFuseSearchText.propTypes = {
    store: FuseSearchTextStore.PropType.isRequired,
};
